export default {"src":"/_next/static/media/icon-flag-hongkong.d414256e.svg","height":27,"width":40,"blurWidth":0,"blurHeight":0};